const CHUNK_RELOAD_KEY = 'chunkReloadAt';
const CHUNK_RELOAD_WINDOW_MS = 10000;

export const isChunkLoadError = (error) =>
    error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || '');

/**
 * Catch handler for lazy page imports. A tab opened before a deploy asks for chunks of the
 * previous build, which no longer exist: reload once to get the new index.html. A second failure
 * within the window is a real error and is rethrown, as is any other error.
 */
export const reloadOnChunkError = (error, reload = () => window.location.reload()) => {
    if (!isChunkLoadError(error)) {
        throw error;
    }
    try {
        const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0;
        if (Date.now() - lastReload < CHUNK_RELOAD_WINDOW_MS) {
            throw error;
        }
        sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    } catch (e) {
        // already reloaded, or no storage to detect a reload loop: show the error
        throw error;
    }
    reload();
    // keep the page as it is until the reload happens
    return new Promise(() => {});
};
